import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { ScrollTable } from './ScrollTable';
import { moduleComparison, moduleIncludes } from '../data/content';
export function ModuleSection() {
  return <section className="w-full bg-surface px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="modulo-title" data-id="element-158" data-mp="16bxs7044ao77">
      <div className="mx-auto max-w-5xl" data-id="element-159" data-mp="wk0hrvkxo09j">
        <SectionHeading eyebrow="🏋️ Manual Muscle Up Blueprint" title="¿Qué agrega el Manual Muscle Up Blueprint?" data-id="element-160" data-mp="wj8jgczybofk" />

        <div className="mt-10" data-id="element-161" data-mp="11cl4ye9c3f43">
          <ScrollTable data-id="element-162" data-mp="nk50d90sb912">
            <table className="w-full min-w-[640px] border-collapse text-left" data-id="element-163" data-mp="nkn7x1swd9oa">
              <caption className="sr-only" data-id="element-164" data-mp="rlyyb9jlhyxj">
                Comparación entre entrenar sin el Manual Muscle Up Blueprint y
                con él
              </caption>
              <thead data-id="element-165" data-mp="ijzgif0raqtj">
                <tr className="bg-ink" data-id="element-166" data-mp="ikiop40lu0ud">
                  <th scope="col" className="px-5 py-4 text-xs font-extrabold uppercase tracking-wider text-neutral-300" data-id="element-167" data-mp="ijh8ym8n8q6b">
                    Situación en el entrenamiento
                  </th>
                  <th scope="col" className="px-5 py-4 text-xs font-extrabold uppercase tracking-wider text-ember" data-id="element-168" data-mp="399zxir9hd8m0">
                    ❌ Sin manual
                  </th>
                  <th scope="col" className="px-5 py-4 text-xs font-extrabold uppercase tracking-wider text-gold" data-id="element-169" data-mp="2gllxk5yu027t">
                    ✅ Con manual
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-170" data-mp="2ljx6mehay8oz">
                {moduleComparison.map(row => <tr key={row.situation} className="border-t border-line" data-id="element-171" data-mp="1xubbc241wdm9">
                    <th scope="row" className="px-5 py-4 text-sm font-semibold text-white" data-id="element-172" data-mp="1xsi52nxcnves">
                      {row.situation}
                    </th>
                    <td className="px-5 py-4 text-sm text-neutral-500" data-id="element-173" data-mp="1r6kooorm1da">
                      {row.without}
                    </td>
                    <td className="px-5 py-4 text-sm font-medium text-neutral-200" data-id="element-174" data-mp="6j7u82ujtdzm">
                      {row.with}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </ScrollTable>
        </div>

        <div id="modulo-title" className="mt-10 rounded-3xl border border-gold/25 bg-ink p-6 sm:p-8" data-id="element-175" data-mp="3exylee77gv2v">
          <h3 className="text-lg font-extrabold tracking-tight text-gold" data-id="element-176" data-mp="3jwta1wrutduw">
            ✅ El manual incluye:
          </h3>
          <ul className="mt-5 grid gap-3 md:grid-cols-2" data-id="element-177" data-mp="3o07t6wb3aack">
            {moduleIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-178" data-mp="z6amid8msshf">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-179" data-mp="137ntwrrdh3qg" />
                <span className="text-sm text-neutral-300" data-id="element-180" data-mp="2nskk8ivuj79u">{item}</span>
              </li>)}
          </ul>
        </div>

        <p className="mt-6 flex items-start gap-2 text-xs text-neutral-600" data-id="element-181" data-mp="2exwhp0hno3oq">
          <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-182" data-mp="2evtfli38ak3n" />
          Sin el manual seguís teniendo los 6 tomos y los 6 bonos completos.
        </p>
      </div>
    </section>;
}